import { useTranslation } from 'react-i18next';
import { Logo } from '../app-logo';

export function Footer() {
  const { t } = useTranslation();
  return (
    <p className="text-xs text-center text-muted-foreground mt-4 px-10 mx-auto">
      {t('auth.layout.terms.byContinuing')} <br />
      <a
        href="https://www.superduty.app/legal/terms/"
        className="text-primary hover:underline"
      >
        {t('auth.layout.terms.title')}
      </a>
      {t('auth.layout.terms.and')}
      <a
        href="https://www.superduty.app/legal/privacy-policy"
        className="text-primary hover:underline"
      >
        {t('auth.layout.terms.privacyPolicy')}
      </a>
      .
    </p>
  );
}

export function Header() {
  return (
    <div className="flex justify-center mb-7">
      <Logo variant="horizontal" size="lg" />
    </div>
  );
}

export function Layout({ children }: { children: React.ReactNode }) {
  return <div className="w-full max-w-md mx-auto space-y-4">{children}</div>;
}

export const PublicPage = {
  Header,
  Footer,
  Layout,
};
